<section
  class="section-boxed-content"
  [style.--padding-top.px]="design().padding.top"
  [style.--padding-bottom.px]="design().padding.bottom"
>
  <div class="section-boxed-content__box" [paiLexicalRichText]="data().text"></div>
</section>
